import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { grid, maxWidthContainer } from '@noths/polaris-client-ribbons-base';
import { PartnerProfile } from "./PartnerProfile";
import * as styles from "./PartnerBlock.styles";
export var PartnerBlock = function PartnerBlock(_ref) {
  var copy = _ref.copy,
    currency = _ref.currency,
    heading = _ref.heading,
    lazyImages = _ref.lazyImages,
    _onPartnerClick = _ref.onPartnerClick,
    _onProductClick = _ref.onProductClick,
    _ref$onProductVisible = _ref.onProductVisible,
    onProductVisible = _ref$onProductVisible === void 0 ? function () {} : _ref$onProductVisible,
    _ref$onVisible = _ref.onVisible,
    onVisible = _ref$onVisible === void 0 ? function () {} : _ref$onVisible,
    partners = _ref.partners;
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    partnersRef = _useVisibilityObserve.observedElementRef;
  return /*#__PURE__*/React.createElement("section", {
    ref: partnersRef
  }, /*#__PURE__*/React.createElement(_StyledHeader, null, /*#__PURE__*/React.createElement(_StyledH, {
    $_css: styles.heading
  }, heading), /*#__PURE__*/React.createElement(_StyledP, {
    $_css2: styles.copy
  }, copy)), /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css3: styles.partners
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css4: [maxWidthContainer, grid]
  }, partners.map(function (partner, partnerIndex) {
    return /*#__PURE__*/React.createElement(PartnerProfile, _extends({
      currency: currency,
      key: partner.url
    }, partner, {
      lazyImages: lazyImages,
      onPartnerClick: function onPartnerClick(e) {
        return _onPartnerClick === null || _onPartnerClick === void 0 ? void 0 : _onPartnerClick(e, {
          partnerIndex
        });
      },
      onProductClick: function onProductClick(e, _ref2) {
        var productIndex = _ref2.productIndex;
        return _onProductClick === null || _onProductClick === void 0 ? void 0 : _onProductClick(e, {
          partnerIndex,
          productIndex
        });
      },
      onVisible: function onVisible() {
        return onProductVisible({
          partnerIndex
        });
      }
    }));
  }))));
};
var _StyledHeader = _styled("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), maxWidthContainer);
var _StyledH = _styled2("h2")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledP = _styled3("p")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = /*#__PURE__*/_styled5("div").withConfig({
  displayName: "PartnerBlock___StyledDiv2",
  componentId: "sc-241iv1-0"
})(["", ""], function (p) {
  return p.$_css4;
});